// -- Semantic layout tokens -----------------------------------------------
//
// Reusable spacing values for consistent page layouts across the app.
// These use Chakra spacing scale numbers (which resolve to rem) so they
// scale with the user's browser font size for accessibility.
//
// Usage:
//   import { pageContentPadding } from '@duke-hq/ui/theme/tokens';
//   <Container px={pageContentPadding.x} py={pageContentPadding.y}>

export const pageContentPadding = {
  x: { base: 6, md: 12 },
  y: { base: 8, md: 12 },
} as const;
